import { local } from "./ApiConfig";

let ImsToken = JSON.parse(localStorage.getItem("ImsToken"))


console.log("ïms", ImsToken)

export const GetToken = (token) => {
    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("authorization", `Bearer: ${token}`);

    return fetch(`${local}/api/v1/user/gettoken`, {
        method: 'GET',
        headers: headers
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const signIn = (Payload) => {

    return fetch(`${local}/api/v1/user/login`, {

        method: 'POST', // or 'PUT'
        headers: {
            'Content-Type': 'application/json',
        },

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}


export const CreateUser = (Payload) => {

    return fetch(`${local}/api/v1/user/registration`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const ConfirmPickUp = (id) => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/request/pickup/${id}`, {

        method: 'PUT',
        headers: headers,

    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const ApproveSRA = (Payload, id) => {

    console.log("approve", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/supervisor/supervisorsraapproval/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const RejectSRA = (Payload, id) => {

    console.log("approve", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/techsupervisor/techsupervisorsrarejection/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const ApproveSCN = (Payload, id) => {

    console.log("approve", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/supervisor/supervisorscnapproval/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const RejectSCN = (Payload, id) => {

    console.log("approve", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/techsupervisor/techsupervisorscnrejection/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const ApproveRequest = (Payload, id) => {

    console.log("approve", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/supervisor/supervisorrequestapproval/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}

export const RejectRequest = (Payload, id) => {

    console.log("Request reject", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/techsupervisor/techsupervisorrequestrejection/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const ApproveTransfer = (Payload, id) => {

    console.log("approve", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/supervisor/supervisortransferapproval/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const CertifyScn = (Payload, id) => {

    console.log("CertifyScn", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/returntostore/certifyreturntostore/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const UploadInvoice = (Payload, id) => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: Payload,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/sra/uploadinvoice/${id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result)

            return result
        })
        .catch(error => console.log('error', error));



}
export const UploadWaybillFile = (Payload, id) => {




    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: Payload,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/sra/uploadwaybill/${id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result)

            return result
        })
        .catch(error => console.log('error', error));



}
export const UpdateIir = (Payload, id) => {
    console.log("updateiir", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/iir/updateiir/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            console.log("data upload", data)
            return data

        })
        .catch((error) => {

            console.error('Errors:', error.message);
            throw new Error("Network error, please contact Administrator")

        });

}
export const InventoryAcc = (Payload, id) => {
    console.log("InventoryAcc", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/inventoryaccount/accountiirapproval/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const QtyUpdatePickUpApi = (Payload, id) => {
    

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/request/updateqtyrequest/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const QtyUpdateRequest = (Payload, id) => {
    console.log("QtyUpdateRequest", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/supervisor/updateqtyrequest/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const QtyUpdateTransfer = (Payload, id) => {
    console.log("transferqty", Payload, id)

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/supervisor/updateqtytransfered/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const ReturnSupervisor = (Payload, id) => {


    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/request/returntosupervisor/${id} `, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}

export const ReadAllRequest = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/request/readallrequest`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const ReadAllRequestDeviceAssignment = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/deviceassigment/readallrequestsfromdeviceassigment`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const ReadAllProcurementDeviceAssignment = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/deviceassigment/readallsraproductsfromdeviceassigment`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const ReadAllRTSDeviceAssignment = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/deviceassigment/readallscnfromdeviceassigment`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const ReadAllGroupRequest = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/request/groupreadallrequest`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const SingleTicketNumber = (ticketNumber) => {

    console.log("ticketNumber", ticketNumber)
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/request/readrequestbyticketnumber/${ticketNumber}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const ReadRequestHistory = (id) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/request/readfirstfiverequest/${id}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllUsers = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/user/allusers`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const AllSraProduct = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/sra/allsraproducts `, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const AllApprovedInventoryAPI = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/sra/readallapprovedinventoryaccount`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const AllUser = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/user/allusers`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const AllSCN = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/returntostore/allscns`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const ExpectedAllSCN = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/expectedreturn/readallreadexpectedreturnrequests`, requestOptions)
        .then((response) => response.json())
        .then((data) => {

            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllStores = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };



    return fetch(`${local}/api/v1/store/allstores`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllName = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };



    return fetch(`${local}/api/v1/deviceassigment/namesavailableondeviceassigment`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllUserType = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/user/getusertypes`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllCategories = () => {
    let headers = new Headers();

    headers.append("Authorization", `Bearer: ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: headers,

    };

    return fetch(`${local}/api/v1/category/allcategorys`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllProductShelf = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/productshelf/readallshelfs`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const GetAllProductShelfWithoutDA = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/productshelf/readshelfswithoutdeveiceasigment`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllProductBinShelf = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/bin/readallshelfs`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const ReadBinApi = (id, store) => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/bin/readbin/${id}/${store}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllTransfer = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/productshelf/readalltransfer`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllSRA = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${local}/api/v1/sra/readallsra `, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetPendingSRA = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${local}/api/v1/supervisor/readpendingsupervisorsraapproval `, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetPendingSCN = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${local}/api/v1/supervisor/readpendingsupervisorscnapproval`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const GetPendingRequest = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${local}/api/v1/supervisor/readpendingsupervisorrequestapproval`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetPendingTransfer = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${local}/api/v1/supervisor/readpendingsupervisortransferapproval`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}


export const GetDashboard = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/dashboard`, requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result)

            return result
        })
        .catch(error => {
            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")
        });

}
export const GetPendingScn = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/returntostore/readpendingscn`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllPendingSRA = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/iir/readallpendingiir`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllProduct = (id) => {

    console.log("shelfid", id)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/stock/readstockingpendingfinancialofficer/${id}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllPendingStock = (id) => {

    console.log("shelfid", id)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/stock/readpendingstoresupervisor/${id}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const GetAllPendingInventory = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/stock/readpendingtlinventory`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const GetAllReport = (shelf, type, from, to) => {

    console.log("report data", shelf, type, from, to)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${local}/api/v1/reports/${shelf}/${type}/${from}/${to}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const GetAllInspectedSra = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/inventoryaccount/readallinspectedsra`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const GetAllPendingStore = () => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${local}/api/v1/stock/readpendingstorehdo`, requestOptions)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const UpdateStatus = (id) => {

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/user/updatestatus/${id}`, {

        method: 'PUT',
        headers: myHeaders,

    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}



export const CreateStore = (Payload) => {

    return fetch(`${local}/api/v1/store/create`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const CreateUserApi = (Payload) => {
    console.log("createUserAPi",Payload)

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/user/registration`, {

        method: 'POST',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const UpdatedUserApi = (Payload, id) => {
    console.log("UpdatedUserApi",Payload, "id", id)

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/user/updateuserothers/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}
export const UpdateUserApi = (id) => {
    console.log("UpdateUserApi",id)

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/user/updatestatus/${id}`, {

        method: 'PUT',
        headers: headers,

    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const ScheduleStock = (id) => {

    return fetch(`${local}/api/v1/stock/schedulestocks/${id}`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },

        // body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const SubmitStockAPI = (id) => {

    return fetch(`${local}/api/v1/stock/createstocks/${id}`, {

        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },

        // body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const DownloadTemplate = (id) => {
    console.log("id temp", id)

    return fetch(`${local}/api/v1/stock/downloadtemplate/${id}`, {

        method: 'Get',
        headers: {
            'Content-Type': 'application/json',
        },

        // body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const UploadDownloadedTemplate = (form) => {
    console.log("formdata", form)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);

    var formdata = new FormData();
    formdata.append("file", form);
  
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

   return fetch(`${local}/api/v1/stock/bulkstockcreation`, requestOptions)
        .then(response => response.json())
        .then(result =>{
            
            return result
        })
        .catch(error => console.log('error', error));

}


export const CreateCategory = (Payload) => {

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/category/create`, {

        method: 'POST',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const StoreSupervisor = (Payload) => {

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/stock/hdostockapproval`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const TeamLeadApproval = (Payload) => {

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/stock/tlfinanceapproval`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}

export const UpdateStoreApi = (Payload, id) => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);



    return fetch(`${local}/api/v1/store/updatestore/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}

export const UpdateCategoryApi = (Payload, id) => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/category/updatecategory/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const UpdateProductShelf = (Payload, id) => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    console.log("api payload", Payload, id);
    return fetch(`${local}/api/v1/productshelf/updateshelf/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const TransferStoreApi = (Payload, id) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    console.log("api payload", Payload, id);
    return fetch(`${local}/api/v1/productshelf/transfer/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const IntegrateApi = (Payload, id) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    console.log("api payload", Payload, id);
    return fetch(`${local}/api/v1/productshelf/updateshelfsfromdeviceassigment/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}

export const CreateShelf = (Payload) => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    var requestOptions = {
        method: 'GET',
        headers: headers,
        body: "",

    };



    console.log("pay", Payload)
    return fetch(`${local}/api/v1/productshelf/create`, {

        method: 'POST',
        headers: headers,
        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const UpdateBinAPi = (Payload, id) => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);




    console.log("pay", Payload)
    return fetch(`${local}/api/v1/productshelf/updateminmaxreorder/${id}`, {

        method: 'PUT',
        headers: headers,
        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}

export const CreateSCN = (Payload) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);


    console.log("payscn", Payload)
    return fetch(`${local}/api/v1/returntostore/create`, {

        method: 'POST',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const CreateExpectedNewSCN = (Payload, id) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);



    return fetch(`${local}/api/v1/expectedreturn/create/${id}`, {

        method: 'POST',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const SaveInventoryStock = (Payload, id) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);



    return fetch(`${local}/api/v1/stock/save/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}



//create suppliers
export const CreateSupplier = (Payload) => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);
    console.log(Payload);
    return fetch(`${local}/api/v1/supplier/create`, {

        method: 'POST',
        headers: headers,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}



//create SRA
export const CreateSRA = (Payload) => {
    console.log("payloadSra", Payload)
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/sra/create`, {

        method: 'POST',
        headers: myHeaders,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
//create SRA
export const UpdateSRAAPI = (Payload,id) => {
   
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/sra/updatesra/${id}`, {

        method: 'PUT',
        headers: myHeaders,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
export const UpdateProcurementAPI= (Payload,id) => {
    console.log("UpdateProcurement", Payload)
    console.log("UpdateProcurement ID", id)
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${ImsToken}`);


    return fetch(`${local}/api/v1/deviceassigment/updatesrafromdeviceassigment/${id}`, {

        method: 'PUT',
        headers: myHeaders,

        body: JSON.stringify(Payload),
    })
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}
//get all suppliers
export const GetAllSuppliers = () => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    return fetch(`${local}/api/v1/supplier/allsuppliers `)
        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });
}

export const UpdateSupplier = (Payload, id) => {

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${ImsToken}`);

    console.log("api payload", Payload, id);
    return fetch(`${local}/api/v1/supplier/updatesuppliers/${id}`, {

        method: 'PUT',
        headers: headers,

        body: JSON.stringify(Payload),
    })

        .then((response) => response.json())
        .then((data) => {


            return data
        })
        .catch((error) => {

            console.error('Error:', error);
            throw new Error("Network error, please contact Administrator")

        });

}




